__turbopack_context__.v({
  "brand": "xzy0SG_brand",
  "is-small": "xzy0SG_is-small",
  "light-blue": "xzy0SG_light-blue",
  "orange": "xzy0SG_orange",
  "pink": "xzy0SG_pink",
  "purple": "xzy0SG_purple",
  "tag": "xzy0SG_tag",
  "with-background": "xzy0SG_with-background",
  "yellow": "xzy0SG_yellow",
});
